import React, { FC } from "react";
import { Button } from "reactstrap";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Radio, Space, Modal as AntdModal, message } from "antd";

interface SequenceConfigModalProps {
  moduleName: string;
  fieldLabel: string;
  show: boolean;
  tempNumberingMode: "auto" | "manual";
  setTempNumberingMode: (mode: "auto" | "manual") => void;
  canAuto: boolean;
  currentSequence: any;
  activeSequences: any[];
  onSave: () => boolean;
  onClose: () => void;
}

const SequenceConfigModal: FC<SequenceConfigModalProps> = ({
  moduleName,
  fieldLabel,
  show,
  tempNumberingMode,
  setTempNumberingMode,
  canAuto,
  currentSequence,
  activeSequences,
  onSave,
  onClose,
}) => {
  const handleSave = () => {
    const success = onSave();
    if (!success) {
      message.error(`Auto-generation is not configured for ${moduleName}.`);
    }
  };

  return (
    <AntdModal
      title={`Configure ${fieldLabel} Number Preference`}
      open={show}
      onCancel={onClose}
      zIndex={1200}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "10px",
          }}
        >
          <Button key="save" color="primary" onClick={handleSave}>
            Save
          </Button>
          <Button key="cancel" color="primary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      }
    >
      <div style={{ marginBottom: 20, lineHeight: "22px" }}>
        Your {fieldLabel} numbers are currently set to auto-generate to save
        time.
        <br />
        Are you sure you want to change this setting?
      </div>

      {!currentSequence && (
        <div style={{ color: "#faad14", marginBottom: 16 }}>
          <InfoCircleOutlined />{" "}
          {activeSequences.length === 0
            ? `No sequences configured for ${moduleName}. Please set up a sequence first in Sequence Master.`
            : "No active sequence found. Please activate a sequence in Sequence Master."}
        </div>
      )}

      <Radio.Group
        onChange={(e) => setTempNumberingMode(e.target.value)}
        value={tempNumberingMode}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Radio value="auto" disabled={!canAuto}>
            <span style={{ fontWeight: 500 }}>
              Continue auto-generating {fieldLabel} numbers
            </span>
            {!canAuto && (
              <span style={{ color: "#8c8c8c", marginLeft: 8, fontSize: 12 }}>
                (Not available - no sequence configured)
              </span>
            )}
          </Radio>

          <Radio value="manual">
            <span style={{ fontWeight: 500 }}>
              Enter {fieldLabel} numbers manually
            </span>
          </Radio>
        </Space>
      </Radio.Group>
    </AntdModal>
  );
};

export default SequenceConfigModal;
